
import React from 'react'
import Pendingorders from './components/orders/Pendingorders'
import Sidenav from './components/Sidenav'

export default function Pendinorders() {
  return (
<div className="flex ">
       <div className="">
       <Sidenav />
       </div>
        <div className="">
            <Pendingorders />
        </div>
    </div>
      )
}
